const BasePath = process.env.HOST || 'http://localhost:3000';

const RailsRoutes = {
    UpliftPath: `${BasePath}/uplift`,
    HubPath: `${BasePath}/hub`,
    SearchPath: `${BasePath}/rv-rentals/search`
};

const Config = {
    AppPath: `${BasePath}/`,
    ADMIN_API_URLS: {
        DASHBOARD_SUMMARY: `${BasePath}/api/v1/summary/dashboard`,
        LISTINGS_AND_TYPES: `${BasePath}/api/v1/summary/listings_and_types`,
        USERS: `${BasePath}/api/users`,
        USERS_SUMMARY: `${BasePath}/api/v1/summary/users`,
        MESSAGES: `${BasePath}/api/conversations`,
        MESSAGES_SUMMARY: `${BasePath}/api/v1/summary/messages`,
        RESERVATIONS: `${BasePath}/api/reservations`,
        RESERVATIONS_SUMMARY: `${BasePath}/api/v1/summary/reservations`,
        LISTINGS: `${BasePath}/api/listings`,
        LISTINGS_SUMMARY: `${BasePath}/api/v1/summary/listings`,
        GUESTS: `${BasePath}/api/guests`,
        GUESTS_SUMMARY: `${BasePath}/api/v1/summary/guests`,
        HOSTS: `${BasePath}/api/hosts`,
        HOSTS_SUMMARY: `${BasePath}/api/v1/summary/hosts`,
        DISPUTES: `${BasePath}/api/disputes`,
        INSURANCE: `${BasePath}/api/insurance_claims`,
        PARTNER_INSURANCE: `${BasePath}/api/partner_insurance`,
        CHECK_IN_OUT_SUMMARY: `${BasePath}/api/v1/summary/check_in_out`,
    },
    RailsRoutes
};

export default Config;